// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

// eslint-disable-next-line no-unused-vars
import {FACTIONS} from '../../../constants/factions';
// eslint-disable-next-line no-unused-vars
import {PLAYER_COLORS} from '../../colors';

export const FACTION_SKINS_ELEMENTALS = [{
  id: 'elementals_water',
  factionId: FACTIONS.ELEMENTALS,
  name: 'Воплощение Воды',
  priceNumens: 9000,
  skinRank: 1,
  colors: [
    PLAYER_COLORS.BLUE,
  ]
}, {
  id: 'elementals_air',
  factionId: FACTIONS.ELEMENTALS,
  name: 'Воплощение Воздуха',
  priceNumens: 17000,
  skinRank: 1,
}, {
  id: 'elementals_stone',
  factionId: FACTIONS.ELEMENTALS,
  name: 'Воплощение Камня',
  priceNumens: 45000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.LIGHT_GREEN,
  ]
}, {
  id: 'elementals_fire',
  factionId: FACTIONS.ELEMENTALS,
  name: 'Воплощение Огня',
  priceNumens: 100000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.RED,
    PLAYER_COLORS.YELLOW,
  ]
}, {
  id: 'elementals_gold_legacy',
  factionId: FACTIONS.ELEMENTALS,
  name: 'Укротитель стихий',
  priceNumens: 100000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
  ],
  excludedFromChests: true
}, {
  id: 'elementals_ruby_legacy',
  factionId: FACTIONS.ELEMENTALS,
  name: 'Сосуд ярости',
  priceCrystals: 250,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.SKY_BLUE,
    PLAYER_COLORS.RED,
  ],
  accentColor: PLAYER_COLORS.RED,
  excludedFromChests: true
}];
